import axiosInstance from './axiosInstance';
import { jwtDecode } from "jwt-decode";

const authService = {
  login: async (credentials) => {
    try {
      const response = await axiosInstance.post('/api/auth/login', credentials);
      if (response.data.token) {
        const decodedToken = JSON.parse(atob(response.data.token.split('.')[1]));
        const userData = {
          id: response.data.user.id,
          username: response.data.user.username,
          name: response.data.user.name,
          email: response.data.user.email,
          headline: response.data.user.headline,
          image: response.data.user.image,
          role: decodedToken.role
        };
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(userData));
        return { 
          token: response.data.token, 
          ...userData
        };
      }
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  signup: async (userData) => {
    try {
      const response = await axiosInstance.post('/api/auth/signup', userData);
      if (response.data.token) {
        const decodedToken = JSON.parse(atob(response.data.token.split('.')[1]));
        const userData = {
          id: response.data.user.id,
          username: response.data.user.username,
          name: response.data.user.name,
          email: response.data.user.email,
          headline: response.data.user.headline,
          image: response.data.user.image,
          role: decodedToken.role
        };
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(userData));
        return { 
          token: response.data.token, 
          ...userData
        };
      }
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getCurrentUser: () => {
    try {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      
      if (token && user) {
        const decodedToken = JSON.parse(atob(token.split('.')[1]));
        const userData = JSON.parse(user);
        
        return {
          token,
          ...userData,
          role: decodedToken.role
        };
      }
      return null;
    } catch (error) {
      console.error('Error getting current user:', error);
      return null;
    }
  },

  getToken: () => {
    return localStorage.getItem('token');
  },

  isTokenValid: () => {
    const token = localStorage.getItem('token');
    if (!token) return false;
    
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      return decoded.exp > currentTime;
    } catch (error) {
      return false;
    }
  },

  updateProfile: async (userData) => {
    try {
      const response = await axiosInstance.put('/api/auth/profile', userData);
      if (response.data.user) {
        const updatedUser = {
          id: response.data.user.id,
          username: response.data.user.username,
          name: response.data.user.name,
          email: response.data.user.email,
          headline: response.data.user.headline,
          image: response.data.user.image
        };
        localStorage.setItem('user', JSON.stringify(updatedUser));
        return updatedUser;
      }
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  deleteAccount: async () => {
    try {
      const response = await axiosInstance.delete('/api/auth/account', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default authService; 